// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/api-explorer": [4],
		"/azure-services": [5],
		"/azure-services/visualization": [6],
		"/client": [7],
		"/contract": [8],
		"/feature-flag": [9],
		"/integrations": [10],
		"/localisation": [11],
		"/mail-ocr": [12,[2]],
		"/mail-ocr/failed-mails": [13,[2]],
		"/mail-ocr/failed-mails/detail": [14,[2]],
		"/mail-ocr/insights": [15,[2]],
		"/mail-ocr/invoice-genie": [16,[2]],
		"/mail-ocr/invoice-genie/issue": [17,[2]],
		"/mail-ocr/queue": [18,[2]],
		"/mail-ocr/queue/document": [19,[2]],
		"/mail-ocr/rules": [20,[2]],
		"/oidc-callback": [21],
		"/reports": [22],
		"/reports/expenseclaimfailedpost": [23],
		"/reports/expenseclaimlocked": [24],
		"/reports/expenseclaimstuckposting": [25],
		"/reports/invoicefailedexport": [26],
		"/reports/invoicefailedpost": [27],
		"/reports/invoicelocked": [28],
		"/reports/invoicestuckexporting": [29],
		"/reports/invoicestuckposting": [30],
		"/reports/purchaseorderemaildetails": [31],
		"/reports/purchaseorderfailedemailsend": [32],
		"/reports/purchaseorderlocked": [33],
		"/sso": [34],
		"/support-tools": [35]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);